export default {
  labs: {
    label: 'Labor',
    filterTitle: 'Nach Status filtern',
    search: 'Laborsuche',
    status: {
      requested: 'Angefordert',
      completed: 'Abgeschlossen',
      canceled: 'Abgebrochen',
    },
    filter: {
      all: 'Alle Status',
    },
    requests: {
      label: 'Laboranfragen',
      new: 'Neue Laboranfrage',
      view: 'Labor anzeigen',
      cancel: 'Labor stornieren',
      complete: 'Labor erledigt',
      error: {
        unableToRequest: 'Unable to create new lab request.',
        unableToComplete: 'Unable to complete lab request.',
        typeRequired: 'Type is required.',
        resultRequiredToComplete: 'Result is required to complete.',
      },
    },
    lab: {
      code: 'Laborcode',
      status: 'Status',
      for: 'Für',
      type: 'Typ',
      result: 'Resultat',
      notes: 'Notizen',
      requestedOn: 'Angefordert am',
      completedOn: 'Erledigt am',
      canceledOn: 'Storniert am',
      patient: 'Patient',
    },
  },
}
